import Reflux from 'reflux'
import React from 'react'
import axios from 'axios'
import _ from 'lodash'
import FontAwesome from 'react-fontawesome'
import { withRouter } from 'react-router-dom'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Navbar, Collapse, Nav, NavItem, NavLink } from 'reactstrap'
import { NotificationManager } from 'react-notifications'

import AppActions from '~/actions/app.js'
import AuthActions from '~/actions/auth.js'
import AuthStore from '~/stores/auth.js'
import RecipesStore from '~/stores/recipes.js'
import RecipesActions from '~/actions/recipes.js'
import CategoriesStore from '~/stores/categories.js'
import QuantitiesActions from '~/actions/quantities.js'
import IngredientsActions from '~/actions/ingredients.js'
import IngredientsTypesActions from '~/actions/ingredientsTypes.js'
// import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
import apiUtils from '../../helper/api.js'

import packageInfo from '../../../package.json'


class Headerbar extends Reflux.Component {
	constructor(props) {
		super(props)

		// store subscriptions
		this.stores = [AuthStore, RecipesStore, CategoriesStore]

		// default state
		this.state = {
			showModalAddRecipe: false,
			categories: [],
			recipeName: '',
			categoryID: 0,
			saveEnabled: false,
			list: [],
			username: ''
		}

		// function bindings
		this.toggleModalAddRecipe = this.toggleModalAddRecipe.bind(this)
		this.setRecipeName = this.setRecipeName.bind(this)
		this.setCategoryID = this.setCategoryID.bind(this)
		this.handleAddNewRecipe = this.handleAddNewRecipe.bind(this)
		this.checkSaveEnabled = this.checkSaveEnabled.bind(this)
	}

	// ********************************************************************************
	// ********************************************************************************

	toggleModalAddRecipe() {
		this.setState({
			showModalAddRecipe: !this.state.showModalAddRecipe,

			recipeName: '',
			categoryID: 0,
			saveEnabled: false
		})
	}

	// ********************************************************************************
	// ********************************************************************************

	setRecipeName(event) {
		this.setState(
			{ recipeName: event.target.value },
			this.checkSaveEnabled
		)
	}

	// ********************************************************************************
	// ********************************************************************************

	setCategoryID(event) {
		this.setState(
			{ categoryID: event.target.value },
			this.checkSaveEnabled
		)
	}

	// ********************************************************************************
	// ********************************************************************************

	checkSaveEnabled() {
		this.setState({ saveEnabled: (this.state.categoryID > 0 && this.state.recipeName !== '') })
	}

	// ********************************************************************************
	// ********************************************************************************

	handleAddNewRecipe() {
		const objCreate = {
			categoryID: parseInt(this.state.categoryID, 10),
			recipe: this.state.recipeName
		}

		// console.log('create!', objCreate);

		axios.post(`${apiUtils.getApiURL()}/recipes`, objCreate)
			.then((response) => {
				this.setState({
					recipeName: '',
					categoryID: 0
				})

				// refresh recipe list
				RecipesActions.get()

				// navigate to new entry
				this.props.history.push(`/recipe/${response.data.recipeID}`)

				// close the modal add window
				this.setState({
					showModalAddRecipe: false
				})
			})
			.catch((error) => {
				NotificationManager.error(
					`Could not add new recipe\n\n${error}`,
					'Error adding recipe'
				)
			})
	}

	// ********************************************************************************
	// ********************************************************************************

	render() {
		const mappedCategories = _.sortBy(this.state.categories, ['category']).map(theCategory =>
			<Button
				color="primary"
				value={theCategory.categoryID}
				key={theCategory.categoryID}
				onClick={this.setCategoryID}
				style={{ textAlign: 'left', marginBottom: '0.1em' }}
				active={parseInt(this.state.categoryID, 10) === theCategory.categoryID}
				className="w-100"
			>
				{theCategory.category}
			</Button>
		)

		if (
			this.state.showModalAdd === true
			&& document.getElementById('newRecipeName')
		) {
			// console.log(document.getElementById('newRecipeName'))
			document.getElementById('newRecipeName').focus()
		}

		return (
			<div>
				<Modal isOpen={this.state.showModalAddRecipe === true}>
					<ModalHeader>
						Add New Recipe
					</ModalHeader>
					<ModalBody>
						<p>
							Name:<br />
							<input
								id="newRecipeName"
								type="text"
								value={this.state.recipeName}
								onChange={this.setRecipeName}
								className="w-100"
								maxLength="64"
							/>
						</p>
						<p>
							Category:<br />
							{mappedCategories}
						</p>
					</ModalBody>
					<ModalFooter>
						<Button
							color="primary"
							disabled={!this.state.saveEnabled}
							onClick={this.handleAddNewRecipe}
						>Save</Button>
						<Button onClick={this.toggleModalAddRecipe}>Close</Button>
					</ModalFooter>
				</Modal>

				<div>
					<h1>
						{'BrandysRecipes.com'}
						<small>
							v{packageInfo.version}
						</small><br />
						<span>Serving up {_.size(this.state.list)} items</span>

						<div className="float-right logIn">
							{ this.state.username === '' &&
								<span>
									Hello, guest
									<Button color="link" onClick={AppActions.showLoginModal}>
										<FontAwesome name="sign-in" />
										&nbsp;
										Log In
									</Button>
								</span>
							}
							{ this.state.username !== '' &&
								<span>
									Logged in as: { this.state.username}
									<Button color="link" onClick={AuthActions.logout}>
										<FontAwesome name="sign-out" />
										&nbsp;
										Log Out
									</Button>
								</span>
							}
						</div>
					</h1>
				</div>

				<Navbar color="primary">
					<Collapse isOpen navbar />
					<Nav>
						<NavItem>
							<NavLink href="/#/">
								<FontAwesome name="home" />
								&nbsp;
								View Recipes
							</NavLink>
						</NavItem>

						<NavItem>
							<NavLink href="/#/shopping">
								<FontAwesome name="home" />
								&nbsp;
								Shopping List
							</NavLink>
						</NavItem>

						{
							this.state.authenticated &&

							<React.Fragment>
								<NavItem>
									<NavLink onClick={this.toggleModalAddRecipe}>
										<FontAwesome name="plus" />
										&nbsp;
										Add Recipe
									</NavLink>
								</NavItem>

								&nbsp;

								<NavItem
									onClick={QuantitiesActions.showModal}
								>
									<NavLink>
										<FontAwesome name="hashtag" />
										&nbsp;
										Quantities
									</NavLink>
								</NavItem>

								&nbsp;

								<NavItem
									onClick={IngredientsActions.showModal}
								>
									<NavLink>
										<FontAwesome name="list" />
										&nbsp;
										Ingredients
									</NavLink>
								</NavItem>

								&nbsp;

								<NavItem
									onClick={IngredientsTypesActions.showModal}
								>
									<NavLink>
										<FontAwesome name="list" />
										&nbsp;
										Ingredient Types
									</NavLink>
								</NavItem>

								{/*
								&nbsp;

								<NavItem>
									<NavLink
										onClick={() => alert('Sorry, not ready yet!')}
									>
										<FontAwesome name="shopping-cart" />
										&nbsp;
										Shopping List
									</NavLink>
								</NavItem>
								*/}
							</React.Fragment>
						}
					</Nav>
				</Navbar>
			</div>
		)
	}
}

export default withRouter(Headerbar)



// WEBPACK FOOTER //
// ./src/modules/layout/headerbar.jsx